import { css } from '@emotion/react';
import { lighten } from '@mui/material/styles';

const makeRadioInputStyles = (theme) => {
  return {
    textLinkContainer: css({
      textAlign: 'center',
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
    }),
    textLink: css({
      fontWeight: 'bold',
      color: `${theme.mvf.palette.text.primaryTextColor} !important`,
      cursor: 'pointer',
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
      textDecorationColor: theme.mvf.palette.text.primaryTextColor,
      fontSize: theme.mvf.fontSize.mini,
      [theme.breakpoints.up('mobileMedium')]: {
        fontSize: theme.mvf.fontSize.small,
      },
      [theme.breakpoints.up('tabletSmall')]: {
        fontSize: theme.mvf.fontSize.compact,
      },
      [theme.breakpoints.up('desktopMedium')]: {
        fontSize: theme.mvf.fontSize.medium,
      },
      '&:hover': {
        textDecoration: 'underline',
        textDecorationColor: theme.mvf.palette.text.primaryTextColor,
        color: `${lighten(
          theme.mvf.palette.text.primaryTextColor,
          0.3
        )} !important`,
      },
    }),
    radioContainer: css({
      marginTop: '1rem',
    }),
  };
};

export default makeRadioInputStyles;
